import React from 'react';
import { useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Text } from '@fhs/ui';
import ConfirmDialog from 'components/confirm-dialog';
import { useOrderContext } from 'state/order';

type SwitchServiceModeDialogProps = {
  showDialog: boolean;
  onConfirm?: () => void;
  onDismiss: () => void;
  // default is FALSE
  // since the default action should be switching between store locations
  switchingFromPickUpToDelivery?: boolean;
};

export const SwitchServiceModeDialog = ({
  showDialog,
  onConfirm = () => {},
  onDismiss,
  // if TRUE
  // this should be displayed from 'delivery-address-form-footer.tsx'
  // at the moment the user chooses to go from pick up to delivery
  switchingFromPickUpToDelivery = false,
}: SwitchServiceModeDialogProps) => {
  const { formatMessage } = useIntl();
  const { emptyCart } = useOrderContext();

  const handleChangeServiceModeConfirmation = () => {
    emptyCart();

    onDismiss();
    onConfirm();
  };

  let confirmationTitle = switchingFromPickUpToDelivery
    ? formatMessage({ id: 'changeServiceModeToDeliveryConfirmationTitle' })
    : formatMessage({ id: 'changeServiceModeConfirmationTitle' });

  return (
    <ConfirmDialog
      showDialog={showDialog}
      onConfirm={handleChangeServiceModeConfirmation}
      onDismiss={onDismiss}
      onCancel={onDismiss}
      confirmLabel={formatMessage({ id: 'changeServiceModeConfirmationConfirm' })}
      cancelLabel={formatMessage({ id: 'cancel' })}
      ariaLabel={confirmationTitle}
      modalAppearanceEventMessage={confirmationTitle}
      headingComponent={<Text.Heading type="one">{confirmationTitle}</Text.Heading>}
      bodyComponent={
        <Text style={styles.dialogMessage}>
          {formatMessage({ id: 'changeServiceModeConfirmationMessage' })}
        </Text>
      }
    />
  );
};

const styles = StyleSheet.create({
  dialogMessage: {
    marginVertical: 16,
    lineHeight: 24,
  },
});
